import { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function Section({ children, className, id }: { children: ReactNode; className?: string; id?: string }) {
  return (
    <section id={id} className={cn("mx-auto max-w-6xl px-6 pt-8 pb-16 sm:py-24", className)}>
      {children}
    </section>
  );
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[hsl(var(--brand-slate))]">
      {children}
    </div>
  );
}

export function PageHeader({ eyebrow, title, lede }: { eyebrow?: string; title: string; lede?: string }) {
  return (
    <div className="max-w-3xl">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h1 className="mt-3 text-4xl sm:text-5xl font-semibold text-[hsl(var(--brand-charcoal))] leading-[1.05]">{title}</h1>
      {lede && <p className="mt-5 text-lg text-[hsl(var(--brand-slate))] leading-relaxed">{lede}</p>}
    </div>
  );
}
